// extracted by mini-css-extract-plugin
export var callCard = "_s3-0";
export var callMessageButton = "_s3-1";
export var helpIcon = "_s3-3";
export var helpIconContainer = "_s3-4";
export var verticalDivider = "_s3-2";